import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/kefu.png'


const _hoisted_1 = { class: "dialog-header" }
const _hoisted_2 = {
  key: 0,
  class: "qr-code-popup"
}
const _hoisted_3 = { class: "order-query-container" }
const _hoisted_4 = { class: "input-section" }
const _hoisted_5 = {
  key: 0,
  class: "result-section"
}
const _hoisted_6 = { class: "result-content" }
const _hoisted_7 = {
  key: 0,
  class: "no-result"
}
const _hoisted_8 = {
  key: 1,
  class: "order-info"
}
const _hoisted_9 = { class: "order-detail" }
const _hoisted_10 = { class: "order-item" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "order-item" }
const _hoisted_13 = {
  key: 0,
  class: "value"
}
const _hoisted_14 = {
  key: 1,
  class: "value error-status"
}
const _hoisted_15 = {
  key: 0,
  class: "download-section"
}
const _hoisted_16 = { class: "refresh-section" }

import { ref, watch, computed } from 'vue';
import { Search, Service } from '@element-plus/icons-vue';
import { ElMessage } from 'element-plus';
import { get } from '../api/api';

interface OrderResult {
  orderNumber: string;
  title: string;
  status: string;
  downloadUrl?: string;
  ossPath?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderQuery',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  presetOrderNumber: {
    type: String,
    default: '',
  },
},
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const props = __props;

// 检测是否为移动设备
const isMobile = computed(() => {
  return window.innerWidth <= 768;
});

const emit = __emit;

const orderNumber = ref('');
const queryResult = ref<OrderResult | null>(null);
const hasSearched = ref(false);
const showQRCode = ref(false);

// 监听预设订单号的变化
watch(() => props.presetOrderNumber, (newOrderNumber) => {
  if (newOrderNumber) {
    orderNumber.value = newOrderNumber;
    // 只填入订单号，不自动执行查询
  }
}, { immediate: true });

const searchOrder = async () => {
  if (!orderNumber.value.trim()) {
    ElMessage({
      message: '请输入订单号',
      type: 'warning',
    });
    return;
  }

  hasSearched.value = true;

  try {
    // 调用实际的API来查询订单
    const response = await get('/aiGenerate/getOrderDocumentDownload', { orderNumber: orderNumber.value });
    const data = response?.data?.data;
    if (!data) {
      queryResult.value = null;
      ElMessage({
        message: '查询不到该订单',
        type: 'info',
      });
      return;
    }
    // 处理status字段
    let statusText = '';
    switch (data.status) {
      case 0:
        statusText = '生成中';
        break;
      case 1:
        statusText = '已生成';
        break;
      case 99:
        statusText = '异常';
        break;
      default:
        statusText = String(data.status);
    }
    queryResult.value = {
      orderNumber: data.orderNumber || orderNumber.value,
      title: data.title || '',
      status: statusText,
      downloadUrl: data.downloadUrl,
      ossPath: data.ossPath,
    };
    ElMessage({
      message: '查询完成',
      type: 'info',
    });
  } catch (error) {
    queryResult.value = null;
    ElMessage({
      message: '查询失败，请重试',
      type: 'error',
    });
  }
};

const refreshQuery = () => {
  if (orderNumber.value.trim()) {
    searchOrder();
  }
};

const downloadOrder = () => {
  if (queryResult.value?.ossPath) {
    // 创建一个临时的a标签来触发下载
    const link = document.createElement('a');
    link.href = queryResult.value.ossPath;
    link.download = `订单_${queryResult.value.orderNumber}.docx`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    ElMessage({
      message: '开始下载',
      type: 'success',
    });
  } else {
    ElMessage({
      message: '下载链接不可用',
      type: 'error',
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    width: isMobile.value ? '90%' : '500px',
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:visible', $event))),
    "show-close": true,
    center: "",
    class: "mobile-dialog"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "customer-service-icon",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showQRCode.value = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showQRCode.value = false))
        }, [
          _createVNode(_component_el_icon, { class: "service-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Service))
            ]),
            _: 1
          }),
          (showQRCode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "客服二维码",
                  class: "qr-code-image"
                }, null, -1),
                _createElementVNode("div", { class: "qr-code-text" }, "扫码联系客服", -1)
              ])))
            : _createCommentVNode("", true)
        ], 32),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "dialog-title" }, "订单下载", -1))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            modelValue: orderNumber.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((orderNumber).value = $event)),
            placeholder: "30001700678150404",
            class: "order-input",
            size: "large"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            onClick: searchOrder,
            class: "search-btn",
            type: "primary",
            size: "large",
            icon: _unref(Search)
          }, null, 8, ["icon"])
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tip-text" }, [
          _createTextVNode(" 订单号可在微信或支付宝消费账单的"),
          _createElementVNode("span", { class: "highlight" }, "商户订单号"),
          _createTextVNode("中获取； ")
        ], -1)),
        (hasSearched.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "result-title" }, "查询结果", -1)),
              _createElementVNode("div", _hoisted_6, [
                (!queryResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 查询不到该订单！ "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "订单号：", -1)),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(queryResult.value.orderNumber), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "状态：", -1)),
                          (queryResult.value.status !== '异常')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(queryResult.value.status), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_14, "生成异常，请联系客服"))
                        ]),
                        (queryResult.value.status === '已生成' && queryResult.value.ossPath)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: downloadOrder,
                                class: "mobile-button"
                              }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("下载订单")
                                ])),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_button, {
                  onClick: refreshQuery,
                  class: "refresh-btn mobile-button"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" 刷新 ")
                  ])),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value", "width"]))
}
}

})